import { render, staticRenderFns } from "./Advert1Section.vue?vue&type=template&id=b2a1dccc&scoped=true"
import script from "./Advert1Section.vue?vue&type=script&lang=js"
export * from "./Advert1Section.vue?vue&type=script&lang=js"
import style0 from "./Advert1Section.vue?vue&type=style&index=0&id=b2a1dccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a1dccc",
  null
  
)

export default component.exports